import { EnvironmentProviders, Provider, makeEnvironmentProviders } from '@angular/core';

import { FirstPartyTracker } from './first-party/first-party.tracker';
import { GtmService } from './gtm.service';
import { MetrikaService } from './metrika.service';
import { TRACKERS } from './tracker';

/**
 * Registers analytics tracker adapters with the DI tree. Apps call this in
 * their `app.config.ts` providers. Each tracker is provided via
 * `useExisting` so the same singleton serves both its vendor-specific
 * callers (e.g. `MetrikaService.hit`, `GtmService.consent`) and the
 * vendor-neutral `Tracker[]` fan-out used by `AnalyticsService`.
 */
export function provideAnalytics(): EnvironmentProviders {
    const providers: Provider[] = [
        { provide: TRACKERS, useExisting: GtmService, multi: true },
        { provide: TRACKERS, useExisting: MetrikaService, multi: true },
        { provide: TRACKERS, useExisting: FirstPartyTracker, multi: true },
    ];
    return makeEnvironmentProviders(providers);
}
